import React, { useState, useEffect } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';
import { FaPencilAlt } from "react-icons/fa";
import axios from 'axios';
import './style.css'; // Import the CSS file

export default function AddDeptAnnouncements() {
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    users: null, // For Select Users
    files: null, // For Upload Files
  });

  const [options, setOptions] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Fetch users or departments (adjust API endpoint as needed)
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('http://localhost:5544/api/users'); // Replace with actual endpoint
        const users = response.data.map(user => ({
          value: user.id,
          label: user.name
        }));
        setOptions(users);
      } catch (err) {
        setError('Failed to fetch users. Please try again.');
        console.error(err);
      }
    };

    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData({
      ...formData,
      [name]: selectedOption ? selectedOption : null
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      files: e.target.files
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.title || !formData.message || !formData.users) {
      setError('Please fill all required fields.');
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
      formDataToSend.append('message', formData.message);
      formDataToSend.append('users', formData.users.value); // Adjust based on your API
      if (formData.files) {
        for (let file of formData.files) {
          formDataToSend.append('files', file);
        }
      }

      const role = localStorage.getItem('role');
      if (role && ['admin', 'HR', 'Accounts'].includes(role)) {
        formDataToSend.append('author', role);
      } else {
        setError('Invalid or missing user role. Please log in again.');
        return;
      }

      const response = await axios.post('http://localhost:5544/api/deptannouncements/add', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.status === 201) {
        setShowAlert(true);
        setFormData({ title: '', message: '', users: null, files: null });
        setTimeout(() => {
          setShowAlert(false);
          navigate('/dept-announcements');
        }, 2000);
      }
    } catch (err) {
      setError('Failed to add the announcement. Please try again.');
      console.error(err);
    }
  };

  return (
    <div className="container-fluid">
      <h1 style={{ marginTop: '60px', fontSize: '2rem', color: '#0353a4' }}>
        <IoInformationCircle className="salary-icon" /> Announcements Information
      </h1>
      <hr />
      <h2 className="salary-subtitle">
        <TbListDetails className="salary-icon" /> Announcements Details
      </h2>
      <hr />

      {showAlert && <Alert variant="success">Department announcement added successfully!</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="table-container">
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="title">
            <Form.Label>Announcement Title <span style={{ color: 'red' }}> *</span></Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter the announcement title"
              required
            />
          </Form.Group>

          <Form.Group controlId="message" className="mt-3">
            <Form.Label>Announcement Message <span style={{ color: 'red' }}> *</span></Form.Label>
            <Form.Control
              as="textarea"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Enter the announcement message"
              rows={3}
              required
            />
          </Form.Group>

          <Form.Group controlId="users" className="mt-3 select-container">
            <Form.Label>Select Users <span style={{ color: 'red' }}> *</span></Form.Label>
            <Select
              name="users"
              options={options}
              onChange={handleSelectChange}
              value={formData.users}
              isClearable
              placeholder="Select users..."
            />
          </Form.Group>

          <Form.Group controlId="files" className="mt-3">
            <Form.Label>Upload Files (PNG, JPG, JPEG, PDF) (Optional)</Form.Label>
            <Form.Control
              type="file"
              name="files"
              onChange={handleFileChange}
              multiple
              accept="image/png, image/jpeg, image/jpg, application/pdf"
            />
          </Form.Group>

          <div className="py-3">
            <Button variant="primary" type="submit">
              <FaPencilAlt /> Add Announcement
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}